export const CAPTIVE_PORTAL_FILTER_EVENT = 'canvas-agent:captive-portal:filter';
export const CAPTIVE_PORTAL_FOCUS_EVENT = 'canvas-agent:captive-portal:focus';
export const CAPTIVE_PORTAL_REFRESH_EVENT =
	'canvas-agent:captive-portal:refresh';
export const CAPTIVE_PORTAL_CREATE_MODAL_EVENT =
	'canvas-agent:captive-portal:create-modal';
export const CAPTIVE_PORTAL_EDIT_MODAL_EVENT =
	'canvas-agent:captive-portal:edit-modal';
export const CAPTIVE_PORTAL_DELETE_MODAL_EVENT =
	'canvas-agent:captive-portal:delete-modal';
export const CAPTIVE_PORTAL_VOUCHER_MODAL_EVENT =
	'canvas-agent:captive-portal:voucher-modal';
